import React from 'react';
import Typography from '~components/typography';
import { getPropertyImageUrl } from '~utils/js-helper';
import styles from './filter-property-card.module.scss';

interface IFilterPropertyCardProps {
  propertyName: string;
  cityName: string;
  imageName: string;
}

const FilterPropertyCard: React.FC<IFilterPropertyCardProps> = ({
  propertyName,
  imageName,
  cityName,
}) => {
  return (
    <div className={styles.root}>
      {propertyName && <img src={getPropertyImageUrl(imageName)} alt="" className={styles.img} />}
      <Typography variant="body1" fontWeight={600} component="p" style={{ marginTop: 16 }}>
        {`${propertyName} in ${cityName}`}
      </Typography>
    </div>
  );
};

export default FilterPropertyCard;
